import StaticPagesHeader from "components/molecules/StaticPagesHeader";
import { SEO } from "utils/helmet/components/SEO";
import url from "url/index";
import useTranslate from "hooks/useTranslate";

import GloryBackground from "assets/images/glory/not_available_page.svg?react";
import BangerBackground from "assets/images/banger/not_available_banger.webp";

import "./styles.sass";

const NotAvailablePage = () => {
  const t = useTranslate();
  const { VITE_APP_PROJECT_NAME } = import.meta.env;

  let backgroundImage;

  switch (VITE_APP_PROJECT_NAME) {
    case "glory":
      backgroundImage = GloryBackground;
      break;
    case "banger":
      backgroundImage = BangerBackground;
      break;
    default:
      backgroundImage = GloryBackground;
      break;
  }

  return (
    <>
      <SEO
        pathname={`/${url.config.pages.root}/${url.config.pages.notAvailablePage}`}
      />
      <div className="NotAvailablePage">
        <StaticPagesHeader />
        <div className="NotAvailablePage__content">
          <div className="NotAvailablePage__content_header">
            {t("notavailable.header")}
          </div>
          <img
            src={backgroundImage}
            alt="Not_available"
            className="NotAvailablePage__content_bg"
          />
          <div className="NotAvailablePage__content_text">
            {t("notavailable.title")}
          </div>
        </div>
      </div>
    </>
  );
};

export default NotAvailablePage;
